/**
 * Frontend-specific Variant Hooks
 *
 * These hooks provide access to Frontend-specific CVA variants
 * via FrontendThemeContext (populated by Frontend UiProvider).
 *
 * Shared UI components (Button, Input, etc.) come from components/ui of this Theme.
 */

import { useFrontendTheme } from '../state/context/UiProvider'

import type {
  BannerSliderVariants,
  CategoryCardsVariants,
  ProductSliderVariants,
  PromoBlockVariants,
  StarsVariants,
} from '../types'

// =============================================================================
// HOOKS
// =============================================================================

export function useStarsVariants(): StarsVariants {
  return useFrontendTheme()
}

export function useCategoryCardsVariants(): CategoryCardsVariants {
  return useFrontendTheme()
}

export function useBannerSliderVariants(): BannerSliderVariants {
  return useFrontendTheme()
}

export function useProductSliderVariants(): ProductSliderVariants {
  return useFrontendTheme()
}

export function usePromoBlockVariants(): PromoBlockVariants {
  return useFrontendTheme()
}
